var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0781 1.67188V10.1094H21.5156C22.2012 10.1094 22.7812 10.6895 22.7812 11.375C22.7812 12.1133 22.2012 12.6406 21.5156 12.6406H13.0781V21.0781C13.0781 21.8164 12.498 22.3438 11.8125 22.3438C11.0742 22.3438 10.5469 21.8164 10.5469 21.0781V12.6406H2.10938C1.37109 12.6406 0.84375 12.1133 0.84375 11.375C0.84375 10.6895 1.37109 10.1094 2.10938 10.1094H10.5469V1.67188C10.5469 0.986328 11.0742 0.40625 11.8125 0.40625C12.498 0.40625 13.0781 0.986328 13.0781 1.67188Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.b463a9f41170686ace1dd69edef60d68.svg";
export { ForwardRef as ReactComponent };